import * as React from 'react';
import styled, { css } from 'styled-components';

import { AquaTheme as T, isAqua } from '../../aqua/AquaTheme';

interface IProps {
  /** @ignore */
  className?: string;
  /** @ignore */
  children?: React.ReactNode;
  onClick: () => void;
}

const GuideButtonBase = (props: IProps) => 
  <span className={props.className} onClick={props.onClick}>
    {props.children}
  </span>

const GuideButton = styled(GuideButtonBase)`
  float: right;
  color: #37ACE3;
  border: solid 1px #37ACE3;
  border-radius: 4px;
  padding-left: 6px;
  padding-right: 6px;
  margin-left: 2px;
  margin-right: 2px;
  padding-top: 2px;
  padding-bottom: 2px;
  cursor: pointer;
  user-select: none;
  &:hover {
    background: #333;
  }
  // Aqua: a small AquaUI primary button.
  ${isAqua && css`
    margin-top: 4px;
    padding: 4px 14px;
    border: none;
    border-radius: ${T.radius.normal}px;
    background: ${T.colors.primary[1]};
    color: ${T.colors.neutral[100]};
    font: ${T.font.labelSmall};
    box-shadow: ${T.shadows.small};
    transition: background-color ease-in-out ${T.duration}ms;
    &:hover {
      background: ${T.colors.primary[2]};
    }
  `}
`

export { GuideButton }
